import { motion } from "framer-motion";
import { Reveal } from "@/components/site/Reveal";
import { GALLERY } from "@/data/content";

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="relative bg-[#f8fafc] py-24 md:py-32">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <h2 className="font-serif font-light text-[#0f172a] text-4xl sm:text-5xl lg:text-7xl leading-[0.98] tracking-tight">
            <Reveal>Selected</Reveal>
            <Reveal delay={0.08}>Work.</Reveal>
          </h2>
          <p className="text-[#475569] max-w-sm font-light">
            From mosaic and subway detail to large-format stone — recent residential and commercial work across Perth.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 auto-rows-[220px] md:auto-rows-[300px]">
          {GALLERY.map((g, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-6%" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: (i % 4) * 0.08 }}
              data-testid={`gallery-item-${i}`}
              className={`relative overflow-hidden group ${g.h === "tall" ? "row-span-2" : "row-span-1"} ${
                i === 0 ? "col-span-2 lg:col-span-1" : ""
              }`}
            >
              <img
                src={g.src}
                alt={g.alt}
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover transition-transform duration-[1.3s] ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-[#0f172a]/10" />
              <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-[#0f172a]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <p className="overline !text-white/90 !text-[0.6rem]">{g.alt}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
